// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"476":"veranstaltungen","594":"about","596":"gruppen","665":"kontakt"}[chunkId] + "-legacy." + {"476":"9dc7b8bd","594":"71c8c1b5","596":"a40f45cd","665":"1563cb62"}[chunkId] + ".js";
};